import { render, staticRenderFns } from "./cModalCentralCost.vue?vue&type=template&id=580d579e&scoped=true"
import script from "./cModalCentralCost.vue?vue&type=script&lang=js"
export * from "./cModalCentralCost.vue?vue&type=script&lang=js"
import style0 from "./cModalCentralCost.vue?vue&type=style&index=0&id=580d579e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d579e",
  null
  
)

export default component.exports